import { createAction } from 'actions/utils'
import { promiseApiAction } from 'actions/application'
import { harnessesSchema } from 'schemas/harnesses'
import { getHarnessesLoaded } from 'selectors/feature/harnesses'

import * as harnesses from 'services/harnesses'

export const HARNESSES_SUCCESS = 'HARNESSES_SUCCESS'
export const HARNESSES_FAILURE = 'HARNESSES_FAILURE'
export const getHarnesses = () =>
  promiseApiAction({
    asyncFn: harnesses.get,
    successActionType: HARNESSES_SUCCESS,
    failureActionType: HARNESSES_FAILURE,
    schema: harnessesSchema,
    conditionalSelector: getHarnessesLoaded,
  })

export const ADD_HARNESS = 'ADD_HARNESS'
export const addHarness = createAction(ADD_HARNESS, ['harnessId'])

export const REMOVE_HARNESS = 'REMOVE_HARNESS'
export const removeHarness = createAction(REMOVE_HARNESS, ['harnessId'])

export const RESET_HARNESSES = 'RESET_HARNESSES'
export const resetHarnesses = createAction(RESET_HARNESSES)
